// extracted by mini-css-extract-plugin
module.exports = {"space":"Agendados1_space__a9CTt","pendienteReversion":"Agendados1_pendienteReversion__2f7wD","pagoReversado":"Agendados1_pagoReversado__1jMbw"};